export default __webpack_public_path__ + "static/media/IconDesc_SpikedRebar.64.702878c6.png";